module.exports = __webpack_public_path__ + "static/media/icon_green.7bf349b9.svg";